import { TRACK_TYPE, VBaseTrack, type VBaseTrackProps } from '../VBaseTrack';
import { FRAME_SLIDER_SCALE, getStepConfig } from '../VFrameSlider';
import { SLIDER_VARIANT, VSliderContextProvider } from '../VSlider';
import { VFrameTrackSliderContextProvider } from './VFrameTrackSliderContextProvider';
import { VInnerFrameTrackSlider } from './VInnerFrameTrackSlider';
import type { VFrameTrackSliderProps } from './type';

export const VFrameTrackSlider = ({
  autoTracking = true,
  cachedRange,
  disabled,
  highlightedRange,
  marker = true,
  max,
  min,
  preloadedRange,
  readOnly,
  scale = FRAME_SLIDER_SCALE.SCALE_1,
  trackRange,
  value = 1,
  variant = SLIDER_VARIANT.SECONDARY,
  onCachedRangeChange,
  onChange,
  onScaleChange,
  onTrackRangeChange,
  ...rest
}: VFrameTrackSliderProps &
  Omit<React.ComponentPropsWithRef<'div'>, 'onChange'>) => {
  const baseTrackProps = {
    disabled,
    max,
    min,
    readOnly,
    step: getStepConfig(scale).step,
    type: TRACK_TYPE.MULTIPLE_RANGE,
    value:
      (trackRange as VBaseTrackProps<TRACK_TYPE.MULTIPLE_RANGE>['value']) ?? [],
    onChange:
      onTrackRangeChange as VBaseTrackProps<TRACK_TYPE.MULTIPLE_RANGE>['onChange'],
  } as VBaseTrackProps<TRACK_TYPE.MULTIPLE_RANGE>;

  return (
    <VBaseTrack {...baseTrackProps}>
      <VSliderContextProvider
        marker={marker}
        variant={SLIDER_VARIANT.FRAME_TRACK_SLIDER}
      >
        <VFrameTrackSliderContextProvider
          autoTracking={autoTracking}
          cachedRange={cachedRange}
          highlightedRange={highlightedRange}
          preloadedRange={preloadedRange}
          scale={scale}
          trackRange={trackRange}
          value={value}
          variant={variant}
          onChange={onChange}
          onCachedRangeChange={onCachedRangeChange}
          onScaleChange={onScaleChange}
          onTrackRangeChange={onTrackRangeChange}
        >
          <VInnerFrameTrackSlider {...rest} />
        </VFrameTrackSliderContextProvider>
      </VSliderContextProvider>
    </VBaseTrack>
  );
};

VFrameTrackSlider.displayName = 'VFrameTrackSlider';
